import Text from 'components/ui/Text';
import useAppSelector from 'hooks/useAppSelector';
import styled from 'styled-components/macro';
import { selectShowHero } from 'store/reducers/shopSlice';
import { Hero, Usp, Teaser, FeaturedCategories, FeaturedProducts, Faq } from 'components/ui/HomePageBlocks';
import { PageContainer } from 'components/ui/Grid';

const Home = () => {
    const { shop } = useAppSelector(({ shop }) => shop);
    const showHero = useAppSelector(selectShowHero);

    return (
        <>
            <Hero />
            <Usp />
            <PageContainer>
                {!showHero && <Header className="display-2">{shop?.selectedUnit?.name ?? shop?.name}</Header>}
                {(shop?.description || shop?.bodyText) && (
                    <ContentConatiner>
                        {shop?.description && (
                            <Text light className="h2 preformatted text-break">
                                {shop?.description}
                            </Text>
                        )}
                        {shop?.bodyText && (
                            <Text light className="h3  text-break">
                                {shop?.bodyText}
                            </Text>
                        )}
                    </ContentConatiner>
                )}
                <FeaturedCategories />
                <Teaser />
                <FeaturedProducts />
                <Faq />
            </PageContainer>
        </>
    );
};

const Header = styled.h1`
    font-size: 32px;
    margin: 20px 0;
`;

const ContentConatiner = styled.div`
    margin: 24px 0;
`;

export default Home;
